<template>
  <div id="starlets">
    <span>
      <h4 class="starlets-size nomargin">
        Sie haben {{ starlets | starletsSize }}
        <span v-if="moreStarlets"> Favoriten</span>
        <span v-else> Favorit </span> ausgewählt.
      </h4>
    </span>
    <br>
    <div class="col-12">
      <div class="row starlets-items">
        <div v-for="student in starlets" v-bind:key="student.id" class="relative bg-img col-sm-4 col-6 col-xl-6  col-lg-12 col-md-4 starlet" v-bind:style="{ backgroundImage: 'url(' + student.portrait_picture_url + ')' }">
          <div class="close-wrap" @click="removeFromStartlets(student)">
            <i class="close fa fa-times"></i>
          </div>
          <div class="starlet-text absolute">           
            <h4>{{student.firstname}}</h4>
            <p class="pull-left">aus {{student.country.case_name}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default{
  props: ['starlets','students'],
  data: function() {
    return {
      moreStarlets: true
    }
  },
  filters: {
    starletsSize: function(starlets) {
      var starletsSize = 0;
      var self = this;
      for (var i = 0; i < starlets.length; i++) {
        starletsSize += starlets[i].quantity;
      }
      return starletsSize;
    }
  },
  methods: {
  removeFromStartlets: function(student) {
    var self = this;
      self.starlets.splice(self.starlets.indexOf(student), 1);
    if(this.$parent.starlets.length <= 0) {
      this.$parent.formShow = false;
    }
      this.$http.post('/api/student_cataloge_algorithm_lessfav?id=' + student.id);
    }
  },
  watch:{
    starlets: function(){
      if(this.$parent.starlets.length > 1 || this.$parent.starlets.length == 0){
        this.moreStarlets = true;
      }else{
        this.moreStarlets = false;
      }
    }
  }
};
</script>
